import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload, faImage, faCloudUploadAlt } from '@fortawesome/free-solid-svg-icons';
import LoadingSpinner from '../LoadingSpinner';
import AdminFormModal from '../shared/AdminFormModal';

const UploadImageModal = ({ show, onClose, onImageFileChange, onSubmit }) => {
  const [loading, setLoading] = useState(false);

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    onImageFileChange(file);
  };

  const handleSubmit = async () => {
    setLoading(true);
    await onSubmit();
    setLoading(false);
    onClose();
  };

  return (
    <>
      {loading ? <LoadingSpinner /> : null}
      <AdminFormModal
        show={show}
        onClose={onClose}
        title="Görsel Yükle"
        subtitle="Ürün kartlarında ve menü önizlemelerinde kullanılacak görseli seçin."
        icon={faUpload}
        footer={(
          <>
            <div className="admin-modal-footer-secondary">
              <Button variant="secondary" onClick={onClose} disabled={loading} className="modal-cancel-btn">
                İptal
              </Button>
            </div>
            <div className="admin-modal-footer-primary">
              <Button variant="primary" onClick={handleSubmit} disabled={loading} className="modal-save-btn">
                <FontAwesomeIcon icon={loading ? faCloudUploadAlt : faUpload} />
                {loading ? 'Yükleniyor...' : 'Görseli Yükle'}
              </Button>
            </div>
          </>
        )}
      >
        <div className="admin-form-section">
          <div className="admin-form-block">
            <div className="admin-form-block-title">
              <FontAwesomeIcon icon={faImage} />
              Dosya Seçimi
            </div>
            <div className="admin-modal-field">
              <Form.Control type="file" onChange={handleImageUpload} accept="image/*" className="form-input" required />
              <div className="admin-modal-helper">JPG, PNG veya GIF formatında bir dosya seçin.</div>
            </div>
          </div>
        </div>
      </AdminFormModal>
    </>
  );
};

export default UploadImageModal;
